import React from 'react';

/**
 * Experiment Provider that holds static information passed from
 * initialized statsig SDK to a provider that the discover app
 * can consume from.
 *
 * Each experiment should define its own individual context and
 * export its own hook. This is to prevent a given context from
 * becoming bloated and leveraged in too many places.
 *
 * eg:
 * ```typescript
 * return(
 *   <MyNextExperimentContext.Provider value={newExperimentValue}>
 *      <DistanceFilterContext.Provider value={distanceFilterValue}>
 *          {props.children}
 *      </DistanceFilterContext.Provider>
 *   </MyNextExperimentContext.Provider>
 * )
 * ```
 * @param props
 * @returns
 */
export const ExperimentProvider: React.FunctionComponent = (props) => {
    return <>{props.children}</>;
};

export default ExperimentProvider;
